import { STATES } from '../../constants';
import { buildApp } from './app';
import { actions, selectors } from '../../state';

export function Config($stateProvider) {
  'ngInject';

  $stateProvider.state(STATES.INSURANCE_QUESTIONNAIRE, {
    url: `/improve-insurance`,
    disableBreadcrumb: true,
    data: {
      permissions: 'signedIn',
    },
    views: {
      '@': {
        template: '<div id="survey-app"></div>',
        controller: ($element, updStore) => {
          const goToNextStep = () => {
            const state = updStore.getState();
            updStore.dispatch(
              actions.router.stateGo(state.insurance.desiredToState.name, {
                params: state.insurance.desiredToState.params,
              })
            );
          };
          const skip = () => {
            const state = updStore.getState();
            updStore.dispatch(
              actions.router.stateGo(state.insurance.desiredToState.name, {
                params: state.insurance.desiredToState.params,
              })
            );
          };

          buildApp($element[0].querySelector('#survey-app'), {
            goToNextStep,
            skip,
          });
        },
      },
    },
    scrollTop: true,
    analytics: {
      ignore: true,
    },
  });
}
